// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;0,700;1,300&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
    font-family: 'Poppins', sans-serif;
}/* Style the navigation bar */
nav {
    background-color:rgb(188, 219, 231); /* Dark blue background color */
    color: #000; /* White text color */
    font-size: 18px;
    position: sticky;
    top: 0;
    display: flex;
    justify-content: space-between; /* Align buttons to the right */
    padding: 30px 40px; /* Add some padding for spacing */
    align-items: center; /* Vertically align items */
  }
  
  nav ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: flex-end; /* Align items to the right */
    flex-grow: 1; /* Allow the links to take up available space */
  }
  
  nav li {
    margin: 0;
    padding-left: 20px; /* Add some spacing between buttons */
  }
  
  nav a {
    text-decoration: none;
    color: #000; /* White text color */
    transition: color 0.3s ease-in-out;
    padding: 10px;
    border: 2px solid black;
  }
  
  nav a:hover {
    color: #072539; /* Light blue text color on hover */
    background-color: #ffffff;
  }
  
  @media (max-width: 768px) {
    nav ul {
      display: none; /* Hide the navigation links */
      position: absolute; /* Position for the toggle button */
      top: 50px; /* Adjust as needed */
      right: 20px; /* Adjust as needed */
      flex-direction: column;
      background-color: #25274d; /* Dark blue background color */
      border: 1px solid #ffffff; /* White border */
      padding: 10px;
    }
    
    nav ul.active {
      display: flex; /* Show the navigation links when active */
      
    }
  
    .menu-toggle {
      display: block; 
    
      cursor: pointer;
    }
  }`, "",{"version":3,"sources":["webpack://./src/Navigation.css"],"names":[],"mappings":"AACA;IACI,kCAAkC;AACtC,CAAC,6BAA6B;AAC9B;IACI,mCAAmC,EAAE,+BAA+B;IACpE,WAAW,EAAE,qBAAqB;IAClC,eAAe;IACf,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,8BAA8B,EAAE,+BAA+B;IAC/D,kBAAkB,EAAE,iCAAiC;IACrD,mBAAmB,EAAE,2BAA2B;EAClD;;EAEA;IACE,qBAAqB;IACrB,SAAS;IACT,UAAU;IACV,aAAa;IACb,yBAAyB,EAAE,6BAA6B;IACxD,YAAY,EAAE,+CAA+C;EAC/D;;EAEA;IACE,SAAS;IACT,kBAAkB,EAAE,qCAAqC;EAC3D;;EAEA;IACE,qBAAqB;IACrB,WAAW,EAAE,qBAAqB;IAClC,kCAAkC;IAClC,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,cAAc,EAAE,mCAAmC;IACnD,yBAAyB;EAC3B;;EAEA;IACE;MACE,aAAa,EAAE,8BAA8B;MAC7C,kBAAkB,EAAE,mCAAmC;MACvD,SAAS,EAAE,qBAAqB;MAChC,WAAW,EAAE,qBAAqB;MAClC,sBAAsB;MACtB,yBAAyB,EAAE,+BAA+B;MAC1D,yBAAyB,EAAE,iBAAiB;MAC5C,aAAa;IACf;;IAEA;MACE,aAAa,EAAE,0CAA0C;;IAE3D;;IAEA;MACE,cAAc;;MAEd,eAAe;IACjB;EACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;0,700;1,300&display=swap');\r\n*{\r\n    font-family: 'Poppins', sans-serif;\r\n}/* Style the navigation bar */\r\nnav {\r\n    background-color:rgb(188, 219, 231); /* Dark blue background color */\r\n    color: #000; /* White text color */\r\n    font-size: 18px;\r\n    position: sticky;\r\n    top: 0;\r\n    display: flex;\r\n    justify-content: space-between; /* Align buttons to the right */\r\n    padding: 30px 40px; /* Add some padding for spacing */\r\n    align-items: center; /* Vertically align items */\r\n  }\r\n  \r\n  nav ul {\r\n    list-style-type: none;\r\n    margin: 0;\r\n    padding: 0;\r\n    display: flex;\r\n    justify-content: flex-end; /* Align items to the right */\r\n    flex-grow: 1; /* Allow the links to take up available space */\r\n  }\r\n  \r\n  nav li {\r\n    margin: 0;\r\n    padding-left: 20px; /* Add some spacing between buttons */\r\n  }\r\n  \r\n  nav a {\r\n    text-decoration: none;\r\n    color: #000; /* White text color */\r\n    transition: color 0.3s ease-in-out;\r\n    padding: 10px;\r\n    border: 2px solid black;\r\n  }\r\n  \r\n  nav a:hover {\r\n    color: #072539; /* Light blue text color on hover */\r\n    background-color: #ffffff;\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    nav ul {\r\n      display: none; /* Hide the navigation links */\r\n      position: absolute; /* Position for the toggle button */\r\n      top: 50px; /* Adjust as needed */\r\n      right: 20px; /* Adjust as needed */\r\n      flex-direction: column;\r\n      background-color: #25274d; /* Dark blue background color */\r\n      border: 1px solid #ffffff; /* White border */\r\n      padding: 10px;\r\n    }\r\n    \r\n    nav ul.active {\r\n      display: flex; /* Show the navigation links when active */\r\n      \r\n    }\r\n  \r\n    .menu-toggle {\r\n      display: block; \r\n    \r\n      cursor: pointer;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
